import _                         from 'underscore';
import React, { FC, useContext } from 'react';
import { useQuery }              from '@apollo/react-hooks';

import { CorvalHireType, Uuid }             from '@src/types';
import { QueriedSelectFieldProps }          from '../formik';
import { SelectField }                      from '../../../components/forms';
import { queriesHaveData, queriesLoading }  from '@src/store/_apolloUtil';
import { DecisionEngineQueries }            from '@src/queries';
import { formatOption, IFormatOptionValue } from '@src/util';
import { useProjectTermDictionary }         from '@src/hooks';
import { ProjectContext }                   from "@src/views/pages/projects/ProjectIndexPage";


interface HireTypeDropdownProps extends QueriedSelectFieldProps {
    projectId?: Uuid,
    loading?: boolean,
    formatOptions?: object,
}

const defaultProps: HireTypeDropdownProps = {
    loading:       false,
    formatOptions: {}
};

const HireTypeDropdown: FC<HireTypeDropdownProps> = ( _props ) => {

    let { projectId, projectVersionId } = useContext( ProjectContext ),
        { getTerm }                     = useProjectTermDictionary(),
        { formatOptions, ...props }     = _props;

    const queryFragment = DecisionEngineQueries.fragments.HIRE_TYPES.QUERY_RETURN( projectVersionId );

    let getHireTypesReq = useQuery(
        DecisionEngineQueries.queries.GET_HIRE_TYPES( queryFragment ), {
            fetchPolicy: 'cache-and-network'
        } );

    let isLoading = ( props.loading || queriesLoading( getHireTypesReq ) );

    let options = [] as IFormatOptionValue[];

    if( queriesHaveData( getHireTypesReq ) ){

        // Group by business function, sort by name
        options = _.chain( getHireTypesReq.data.hireTypes )
                   .mapObject( v => ( { ...v, businessFunction: v.businessFunction.name } ) )
                   .sortBy( 'businessFunction' )
                   .groupBy( 'businessFunction' )
                   .values().map( set => _.sortBy( set, 'name' ) )
                   .flatten().map( ( h: CorvalHireType ) => formatOption( h.id, h.name, { group: h.businessFunction, ...formatOptions } ) )
                   .value();
    }

    return (
        <SelectField
            useGroupNames={ true }
            { ...props }
            search
            loading={ isLoading }
            options={ options }
        />
    );
};

HireTypeDropdown.defaultProps = defaultProps;

export { HireTypeDropdown };
